import {
    Module,
    VuexModule,
    Mutation,
    Action,
    getModule,
    store,
} from '@samclick-commons';
import { subItems, parents } from '@/assets/scripts/menu/menu';
import { _filter, _find, _findIndex } from '@samclick-lodash';
import * as appStorageUtil from '@/utils/localstorage-util';


@Module({
    namespaced: true, dynamic: true, store, name: 'menu',
})
class MenuStore extends VuexModule {
    menu: Record<string, any>[] = _filter(subItems, { parent: this.parentMenu });

    selectedParentMenu: number = this.parentMenu

      @Mutation
    changeSelectedParentMenu(id: number) {
        this.selectedParentMenu = id;
        this.menu = _filter(subItems, { parent: id });
        if (id === 4) {
            this.menu = _filter(subItems, {
                href: 'beginners',
                title: 'introduction.beginners_guide',
                icon: 'fa fa-newspaper-o',
                parent: 4,
            });
        }
        appStorageUtil.setSessionItem(appStorageUtil.SELECTED_MENU, id);
    }

      @Action({ commit: 'changeSelectedParentMenu' })
      selectParentMenu(id: number) {
          return id;
      }


      get getIndexOfSelectedMenu() {
          const self = this;
          return function (name: string) {
              return _findIndex(this.menu, o => o.href === name) || 0;
          };
      }

      get parentMenu() {
          return parseInt(appStorageUtil.getSessionItem(appStorageUtil.SELECTED_MENU) || '1');
      }
}

export default getModule(MenuStore);
